import { removeWhitespaceAndNewline } from './String-functions';

const REGEX = /^(0|\+44)?[1, 2, 3, 5, 7, 8][0-9]{9}$/;

export const formatPhoneNumber = (phone: string): string => {
  const stripped = removeWhitespaceAndNewline(phone);
  if (!REGEX.test(stripped)) return '';
  if (stripped.slice(0, 3) === '+44') return stripped;
  if (stripped[0] === '0') return `+44${stripped?.slice(1)}`;
  if (['1', '2', '3', '5', '7', '8'].includes(stripped[0]))
    return `+44${stripped}`;
  return stripped;
};

export const removeCountryCode = (phone: string): string => {
  if (!REGEX.test(phone)) return '';
  if (!phone.includes('+44')) return phone;
  return phone?.replace('+44', '0');
};
